import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgLogoLcLarge = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 37,
	viewBox: "0 0 38 37",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1618_5871)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M37.1884 23.076C37.0016 25.2614 35.9947 27.2952 34.37 28.7688C32.7454 30.2425 30.6233 31.0468 28.43 31.0202H23.6L14.4 37.0002V31.0202L23.6 25.0402H28.4392C29.1239 25.0649 29.7925 24.8289 30.3099 24.3798C30.8273 23.9307 31.155 23.302 31.2268 22.6206C31.5081 18.0241 31.485 13.414 31.1578 8.82059C31.1024 8.20787 30.8284 7.63553 30.3859 7.20816C29.9433 6.7808 29.3617 6.52695 28.7474 6.493C25.6102 6.2998 22.3074 6.18019 19 6.18019C15.6926 6.18019 12.3898 6.2906 9.25264 6.51139C8.63835 6.54535 8.05678 6.7992 7.61422 7.22656C7.17165 7.65393 6.89763 8.22627 6.84224 8.83899C6.51507 13.4324 6.49202 18.0425 6.77324 22.639C6.84936 23.317 7.17893 23.9413 7.69588 24.3866C8.21284 24.8319 8.879 25.0653 9.56084 25.0402H14.4V31.0202H9.57004C7.37922 31.042 5.26111 30.2349 3.64026 28.7608C2.01941 27.2867 1.0156 25.2545 0.830038 23.0714C0.525807 18.1686 0.548858 13.2511 0.899038 8.35139C1.07291 6.31956 1.96716 4.41674 3.42048 2.98619C4.8738 1.55565 6.79051 0.691557 8.82484 0.549795C12.1 0.315195 15.55 0.200195 19 0.200195C22.45 0.200195 25.9 0.315195 29.1752 0.549795C31.2157 0.687915 33.1392 1.55276 34.5967 2.98747C36.0541 4.42218 36.9492 6.33173 37.1194 8.36979C37.469 13.2649 37.4921 18.1778 37.1884 23.076Z",
			fill: "#FF5100"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1618_5871",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 36.8,
			height: 36.8,
			fill: "white",
			transform: "translate(0.600098 0.200195)"
		})
	}) })]
});
export default SvgLogoLcLarge;
